import { assertPresentationActive } from './chatPresentationDeadline'
import { ChatExportTranslationError } from './chatExportFailure'
import type { WorkOrderPresenter, PresentationField } from './workOrderPresentation'
type Translate = WorkOrderPresenter['resolve']

/** Exact observed fields (including composed labels), bounded and owned by one scope. */
export function createChatDisplayRegistry() {
  const fields = new Map<string, { locale: string; field: PresentationField }>()
  return {
    clear: () => fields.clear(),
    record(field: PresentationField, locale: string) {
      fields.set(JSON.stringify([locale, field.value]), { locale, field })
      while (fields.size > 6000) fields.delete(fields.keys().next().value!)
    },
    async resolve(locale: string, t: Parameters<Translate>[2], translate: Translate, signal?: AbortSignal) {
      const snapshot = [...fields.values()].filter((entry) => entry.locale === locale)
      for (let index = 0; index < snapshot.length; index += 64) {
        if (signal) assertPresentationActive(signal)
        const results = await Promise.all(
          snapshot.slice(index, index + 64).map(({ field }) => translate(field, locale, t)),
        )
        if (signal) assertPresentationActive(signal)
        const failed = results.findIndex((result) => result.state === 'unavailable')
        if (failed !== -1) throw new ChatExportTranslationError('visible', index + failed)
      }
    },
  }
}
